import Vue from 'vue'
import VueClickOutsideElement from 'vue-click-outside-element'

Vue.use(VueClickOutsideElement)
